module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "apple-touch-icon.533490e1.png";